import React from 'react';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { Controller, useFormContext } from 'react-hook-form-legacy';
import {
  SelectMultiple,
  Props as SelectMultipleProps,
} from '../../../apps/dashboard/components/Selects/SelectMultiple';

type Props = Omit<SelectMultipleProps, 'values' | 'onChange'> & {
  name: string;
};

export const SelectMultipleControlled: React.FC<
  React.PropsWithChildren<Props>
> = (props) => {
  const { control } = useFormContext();

  return (
    <Controller
      as={({ value, onChange }) => {
        return <SelectMultiple {...props} values={value} onChange={onChange} />;
      }}
      name={props.name}
      control={control}
    />
  );
};
